import React, { Component } from "react";
import { toast } from "react-hot-toast";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faCross, faTrash } from "@fortawesome/free-solid-svg-icons";
// import { getFileName } from "../../../Utils/getFileName";
import withRouter from "../../components/withRouter/withRouter";
import {
  addUpdateApi,
  getByIdApi,
  uploadImageApi,
  getCategoriesApi,
  deleteByIdApi,
} from "../../api";
import he from "he";
import CategoryDropDown from "../../components/categoryDropDown/CategoryDropDown";
import { isValidURL } from "../../utils/isValidUrl";

class CreateBlog extends Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    content: "", // body
    title: "",
    shortDescription: "", // description
    category: "",
    tagText: "",
    subTitle: "",
    tags: [],
    adOneUrl: "",
    adTwoUrl: "",
    buttonOneUrl: "",
    buttonTwoUrl: "",
    loading: false,
    isImageChanged: false,
    author: "",
    metaTitle: "",
    slug: "",
    metaDescription: "",
    metaImageUrl: "",
    canonicalUrl: "",
    categories: [],
  };

  componentDidMount() {
    this.getCategories();
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  }

  getCategories = () => {
    getCategoriesApi()
      .then((res) => {
        const d = res.data.filter((val) => val.categoryType === "Blog");

        this.setState({ categories: d });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getData = () => {
    getByIdApi("article", this.props.router.params.id)
      .then((res) => {
        const temp = res.data;
        console.log(temp);
        this.setState({
          imageUrl: temp?.blogImage,
          imageCaption: temp?.blogCaption,
          imageAlt: temp?.blogAlt,
          title: temp?.blogTitle,
          tags: temp?.keywords,
          category: temp?.category,
          subTitle: temp?.subTitle,
          shortDescription: temp?.shortDescription,
          content: he.decode(temp?.blogContent || ""),
          metaDescription: temp?.metaData?.metaDescription,
          metaImageUrl: temp?.metaData?.metaImageUrl,
          loading: false,
          slug: temp?.metaData?.slug,
          metaTitle: temp?.metaData?.metaTitle,
          canonicalUrl: temp?.metaData?.canonicalUrl,
        });
      })
      .catch((err) => {
        toast.error("Something went wrong while getting blog data.");
        this.props.router.navigate("/blogs");
      });
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
      isImageChanged: true,
    });
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Banner Image is required.");
      return false;
    }

    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }

    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }

    if (!this.state.title) {
      toast.error("Blog Title is required.");
      return false;
    }

    if (this.state.tags.length === 0) {
      toast.error("Keywords are required.");
      return false;
    }

    if (!this.state.category) {
      toast.error("Category is required.");
      return false;
    }

    if (!this.state.subTitle) {
      toast.error("Sub Title is required.");
      return false;
    }

    if (!this.state.shortDescription) {
      toast.error("Short Description is required.");
      return false;
    }

    if (!this.state.content) {
      toast.error("Blog Content is required.");
      return false;
    }

    if (!this.state.slug) {
      toast.error("Slug is required.");
      return false;
    }

    if (!this.state.metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }

    if (!this.state.metaImageUrl) {
      toast.error("Meta Image Url is required.");
      return false;
    }

    if (!isValidURL(this.state.metaImageUrl)) {
      toast.error("Please enter a valid meta image url.");
      return false;
    }

    if (!this.state.canonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }

    if (!isValidURL(this.state.canonicalUrl)) {
      toast.error("Please enter a valid canonical url.");
      return false;
    }

    if (!this.state.metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }

    return true;
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "article"
        );
        console.log(response);
        return response.data.imageUrl;
      } catch (error) {
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  handleSubmit = (event) => {
    console.log("updating it .....");
    if (event.target.name === "btn3") {
      this.props.router.navigate("/blogs");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });

        this.uploadImage()
          .then((r) => {
            addUpdateApi({
              data: {
                category: this.state.category,
                blogImage: r,
                blogTitle: this.state.title,
                blogCaption: this.state.imageCaption,
                blogAlt: this.state.imageAlt,
                keywords: this.state.tags,
                blogContent: this.state.content,
                subTitle: this.state.subTitle,
                shortDescription: this.state.shortDescription,
                metaData: {
                  metaTitle: this.state.metaTitle,
                  metaImageUrl: this.state.metaImageUrl,
                  metaDescription: this.state.metaDescription,
                  slug: this.state.slug,
                  canonicalUrl: this.state.canonicalUrl,
                },
                status: event.target.name === "btn2" ? "draft" : "published",
              },
              type: "article",
              method: this.props.router.params.id ? "patch" : "post",
              id: this.props?.router?.params?.id,
            })
              .then((res) => {
                toast.success("Article added successfully.");
                this.props.router.navigate("/blogs");
                this.setState({ loading: false });
              })
              .catch((err) => {
                this.setState({ loading: false });
                toast.error(
                  "Something went wrong while creating/updating the article."
                );
              });
          })
          .catch((err) => {
            this.setState({ loading: false });
            toast.error("Error While uploading image.");
          });
      }
    }
  };

  updateBlog = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });

        if (!!this.state.imageUrl && !this.state.isImageChanged) {
          // no need to upload to aws s3

          const data = {
            title: this.state.title,
            description: this.state.shortDescription,
            image: this.state.imageUrl,
            body: this.state.content,
            adOneUrl: this.state.adOneUrl,
            adTwoUrl: this.state.adTwoUrl,
            buttonOneUrl: this.state.buttonOneUrl,
            buttonTwoUrl: this.state.buttonTwoUrl,
            category: this.state.category,
            tags: this.state.tags,
            status: event.target.name === "btn1" ? "live" : "draft",
            others: { author: this.state.author },
          };

          //   callApi({
          //     url: this.props.router.params.id,
          //     data,
          //     method: "patch",
          //     type: "blogs",
          //     header: true,
          //     identifier: true,
          //   })
          //     .then((res) => {
          //       toast.success("Blog Updated Successfully");
          //       this.props.router.navigate("/");
          //       this.setState({ loading: false });
          //     })
          //     .catch((err) => {
          //       console.log("error is : ", err);
          //       toast.error(err.response.data.message);
          //       this.setState({ loading: false });
          //     });
        } else {
          // need to upload image to aws s3
          //   const filename = getFileName(this.state.imageObject);
          //   UploadImage({ file: this.state.imageObject, name: filename })
          //     .then((res) => {
          //       const image_url = filename;
          //       const data = {
          //         title: this.state.title,
          //         description: this.state.shortDescription,
          //         image: image_url,
          //         body: this.state.content,
          //         adOneUrl: this.state.adOneUrl,
          //         adTwoUrl: this.state.adTwoUrl,
          //         buttonOneUrl: this.state.buttonOneUrl,
          //         buttonTwoUrl: this.state.buttonTwoUrl,
          //         category: this.state.category,
          //         tags: this.state.tags,
          //         status: event.target.name === "btn1" ? "live" : "draft",
          //       };
          //       callApi({
          //         url: this.props.router.params.id,
          //         data,
          //         method: "patch",
          //         type: "blogs",
          //         header: true,
          //         identifier: true,
          //       })
          //         .then((res) => {
          //           toast.success("Blog Updated Successfully");
          //           this.props.router.navigate("/");
          //           this.setState({ loading: false });
          //         })
          //         .catch((err) => {
          //           console.log("error is : ", err);
          //           toast.error(err.response.data.message);
          //           this.setState({ loading: false });
          //         });
          //     })
          //     .catch((res) => {});
        }
      }
    }
  };

  deleteCategory = (id) => {
    this.setState({ loading: true });
    deleteByIdApi("category", id)
      .then(() => {
        toast.success("Category deleted successfully.");
        getCategoriesApi()
          .then((res) => {
            const d = res.data.filter((val) => val.categoryType === "Blog");

            this.setState({ categories: d, loading: false });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        toast.error("Something went wrong while deleting category.");
      });
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={this.props?.title ? this.props.title : "Add New Blog"}
            showBtn1={true}
            showBtn2={true}
            showBtn3={true}
            btn1type="filled"
            btn2type="outlined"
            btn3type="outlined_del"
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text={"Save"}
            btn2Text={"Save as Draft"}
            btn3Text={"Cancel"}
            onClickHandler={this.handleSubmit}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <h3>Hero</h3>
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                      marginBottom: "10px",
                    }}
                  >
                    Banner Image
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div style={{ marginBottom: "40px", width: "45%" }}>
                      <div
                        style={{
                          width: "100%%",
                          aspectRatio: "16/9",
                          backgroundImage: `url('${
                            this.props.router.params.id
                              ? this.state.isImageChanged
                                ? this.state.imageUrl
                                : this.state.imageUrl
                              : this.state.imageUrl
                          }')`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          marginTop: "10px",
                          borderRadius: "15px",
                          position: "relative",
                        }}
                      ></div>
                      {this.state.imageObject && (
                        <p style={{ textAlign: "center" }}>
                          {this.state.imageObject?.name}
                        </p>
                      )}
                    </div>
                  )}
                </div>

                {this.state.imageUrl && (
                  <div className="grid_2">
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Caption"}
                      value={this.state.imageCaption}
                      onChange={(e) => {
                        this.setState({ imageCaption: e.target.value });
                      }}
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Alt"}
                      value={this.state.imageAlt}
                      onChange={(e) =>
                        this.setState({ imageAlt: e.target.value })
                      }
                    />
                  </div>
                )}

                <InputField
                  isLabel={true}
                  value={this.state.title}
                  lable={"Blog Title"}
                  type="text"
                  isRequired={false}
                  placeholder={"Blog Heading"}
                  onChange={(event) => {
                    this.setState({ title: event.target.value });
                  }}
                  disabled={
                    this.props.admin?.role === "subadmin"
                      ? !this.props.admin?.blog_access.write
                      : false
                  }
                  showCharLength={true}
                  limitChar={150}
                />

                <div className="grid_2">
                  <div>
                    <InputField
                      type="text"
                      isLabel={true}
                      value={this.state.tagText}
                      lable={"Keywords"}
                      isRequired={false}
                      placeholder={"Comma separated values"}
                      onChange={(e) => {
                        this.setState({ tagText: e.target.value });
                      }}
                      onKeyPress={(event) => {
                        if (event.key === "Enter") {
                          this.setState({
                            tags: [...this.state.tags, this.state.tagText],
                            tagText: "",
                          });
                        }
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        marginTop: "10px",
                      }}
                    >
                      {this.state.tags.map((tag, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              background: "var(--blue-light)",
                              color: "var(--blue-dark)",
                              padding: "5px 10px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            {tag}
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                color: "var(--blue-dark)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                let temp = [...this.state.tags];
                                temp.splice(index, 1);
                                this.setState({ tags: temp });
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <CategoryDropDown
                    categories={this.state.categories}
                    value={this.state.category}
                    placeholder="Select/Add Category"
                    onChange={(v) => this.setState({ category: v })}
                    deleteCategory={this.deleteCategory}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    value={this.state.subTitle}
                    lable={"Sub Title"}
                    isRequired={false}
                    placeholder={"Sub Title"}
                    onChange={(event) => {
                      this.setState({ subTitle: event.target.value });
                    }}
                  />
                </div>

                <InputField
                  type="textarea"
                  isLabel={true}
                  lable="Short description (max. 300 characters)"
                  value={this.state.shortDescription}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (
                      inputValue.length <= 300 ||
                      inputValue.length < this.state.shortDescription.length
                    ) {
                      this.setState({ shortDescription: inputValue });
                    }
                  }}
                  onKeyPress={(e) => {
                    if (
                      e.key === "Backspace" &&
                      this.state.shortDescription.length > 300
                    ) {
                      e.preventDefault();
                      this.setState({
                        shortDescription: this.state.shortDescription.slice(
                          0,
                          -1
                        ),
                      });
                    }
                  }}
                />
              </div>
              <div className="card grid">
                <h3>Blog Content</h3>
                <TextEditor
                  content={this.state.content}
                  handleChange={(value) => {
                    console.log(value);
                    this.setState({ content: value });
                  }}
                  placeholder=""
                />
              </div>
              <div className="card grid">
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) =>
                    this.setState({ slug: e.target.value.replace(" ", "-") })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Image Url"
                  type="text"
                  value={this.state.metaImageUrl}
                  onChange={(e) =>
                    this.setState({ metaImageUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="text"
                  value={this.state.canonicalUrl}
                  onChange={(e) =>
                    this.setState({ canonicalUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(CreateBlog);
